<template>
  <div>
    <SellHeader :img_header="header_image" header="เมนูคำสั่งซื้อ" link_back="sell/all"/>
    <MenuSell/>
    <Order_retail_customers/>
  </div>
</template>

<script>
import MenuSell from "@/components/admin/sell/menusell/MenuSell";
import Order_retail_customers from "@/components/admin/sell/Order_retail_customers";
import SellHeader from "@/components/admin/sell/header_sell/SellHeader";
import HeaderImage from "@/assets/order_all.png";
export default {
  name: "OrderRetailCustomers",
  components: {
    SellHeader,
    Order_retail_customers,
    MenuSell
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
